import axios from 'axios';
import queryString from 'query-string';
import { Cookies } from 'react-cookie';
import apiConfig from '../config/routesApi';

/* begin::Logistic Axios Client */
const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_LOGISTIC,
    headers: {
        'content-type': 'application/json',
    },
    paramsSerializer: params => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
    const cookie = new Cookies();
    const userToken = cookie.get("user_access");
    const tokenRaw = `Bearer ${(userToken ? (typeof userToken == 'object' ? userToken.access_token : JSON.parse(userToken).access_token) : '')}`;
    config.headers.Authorization = tokenRaw;
    return config;
});

axiosClient.interceptors.response.use((response) => {
    if (response && response.data) {
        return response.data;
    }

    return response;
}, (error) => {
    throw error;
});
/* end::Logistic Axios Client */


/* begin::User Axios Client */
const userAxiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_USERS,
    headers: {
        'content-type': 'application/json',
    },
    paramsSerializer: params => queryString.stringify(params),
});

userAxiosClient.interceptors.request.use(async (config) => {
    const cookie = new Cookies();
    const userToken = cookie.get("user_access");
    const tokenRaw = `Bearer ${(userToken ? (typeof userToken == 'object' ? userToken.access_token : JSON.parse(userToken).access_token) : '')}`;
    config.headers.Authorization = tokenRaw;
    return config;
});

userAxiosClient.interceptors.response.use((response) => {
    if (response && response.data) {
        return response.data;
    }

    return response;
}, (error) => {
    throw error;
});
/* begin::User Axios Client */

/* begin::Campaign Axios Client */
const campaignAxiosClient = axios.create({
    baseURL: apiConfig.apiGateway.mainCampaigns,
    headers: {
        'content-type': 'application/json',
    },
    paramsSerializer: params => queryString.stringify(params),
});

campaignAxiosClient.interceptors.request.use(async (config) => {
    const cookie = new Cookies();
    const userToken = cookie.get("user_access");
    const tokenRaw = `Bearer ${(userToken ? (typeof userToken == 'object' ? userToken.access_token : JSON.parse(userToken).access_token) : '')}`;
    config.headers.Authorization = tokenRaw;
    return config;
});

campaignAxiosClient.interceptors.response.use((response) => {
    if (response && response.data) {
        return response.data;
    }

    return response;
}, (error) => {
    throw error;
});
/* end::Campaign Axios Client */

/* begin::Agency Distribute Axios Client */
const distributeAxiosClient = axios.create({
    baseURL: apiConfig.apiGateway.mainDistribute,
    headers: {
        'content-type': 'application/json',
    },
    paramsSerializer: params => queryString.stringify(params),
});

distributeAxiosClient.interceptors.request.use(async (config) => {
    const cookie = new Cookies();
    const userToken = cookie.get("user_access");
    const tokenRaw = `Bearer ${(userToken ? (typeof userToken == 'object' ? userToken.access_token : JSON.parse(userToken).access_token) : '')}`;
    config.headers.Authorization = tokenRaw;
    return config;
});

distributeAxiosClient.interceptors.response.use((response) => {
    if (response && response.data) {
        return response.data;
    }

    return response;
}, (error) => {
    throw error;
});
/* end::Campaign Axios Client */

/* begin::Inbound Axios Client */
const inboundAxiosClient = axios.create({
    baseURL: apiConfig.apiGateway.mainCMMs,
    headers: {
        'content-type': 'application/json',
    },
    paramsSerializer: params => queryString.stringify(params),
});

inboundAxiosClient.interceptors.request.use(async (config) => {
    const cookie = new Cookies();
    const userToken = cookie.get("user_access");
    const tokenRaw = `Bearer ${(userToken ? (typeof userToken == 'object' ? userToken.access_token : JSON.parse(userToken).access_token) : '')}`;
    config.headers.Authorization = tokenRaw;
    return config;
});

inboundAxiosClient.interceptors.response.use((response) => {
    if (response && response.data) {
        return response.data;
    }

    return response;
}, (error) => {
    throw error;
});
/* end::Inbound Axios Client */

const createAxiosClient = (baseURL, contentType) => {
    const axiosClient = axios.create({
        baseURL: baseURL,
        headers: {
            'content-type': contentType,
        },
        paramsSerializer: params => queryString.stringify(params),
    });

    axiosClient.interceptors.request.use(async (config) => {
        const cookie = new Cookies();
        const userToken = cookie.get("user_access");
        const tokenRaw = `Bearer ${(userToken ? (typeof userToken === 'object' ? userToken.access_token : JSON.parse(userToken).access_token) : '')}`;
        config.headers.Authorization = tokenRaw;
        return config;
    });

    axiosClient.interceptors.response.use((response) => {
        if (response && response.data) {
            return response.data;
        }

        return response;
    }, (error) => {
        throw error;
    });

    return axiosClient;
};

const slaAxiosClient = createAxiosClient(process.env.REACT_APP_API, 'application/json');
const slaFormDataAxiosClient = createAxiosClient(process.env.REACT_APP_API, 'multipart/form-data');

const mainAxiosClient = createAxiosClient(process.env.REACT_APP_API, 'application/json');

export {
    axiosClient,
    userAxiosClient,
    campaignAxiosClient,
    inboundAxiosClient,
    distributeAxiosClient,
    slaAxiosClient,
    slaFormDataAxiosClient,
    mainAxiosClient
};